import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import detailsReducer from './detailsPage/data/reducer';
import detailsSagas from './detailsPage/data/sagas';
import listReducer from './listPage/data/reducer';
import listSagas from './listPage/data/sagas';
import routes from './routes';

const reducer = combineReducers({
  detailsPage: detailsReducer,
  listPage: listReducer,
});

const saga = function* () {
  yield all([detailsSagas(), listSagas()]);
};

export { reducer, saga, routes };
